import {useUpmPlantContext} from '@hconnect/upm'

const currencySymbolMap: Record<string, string> = {
  BAM: 'KM',
  BGN: 'лв',
  CHF: 'CHF',
  CZK: 'Kč',
  DKK: 'kr',
  EGP: '£',
  EUR: '€',
  GBP: '£',
  HUF: 'Ft',
  MAD: 'MAD',
  NOK: 'kr',
  PLN: 'zł',
  RON: 'lei',
  RSD: 'Дін.',
  SEK: 'kr',
  TRY: '₺',
  USD: '$'
}

export const getCurrencySymbol = (currencyCode?: string): string => {
  const normalizedCurrencyCode = currencyCode?.trim().toUpperCase()

  if (!normalizedCurrencyCode) {
    return ''
  }

  return currencySymbolMap[normalizedCurrencyCode] ?? normalizedCurrencyCode
}

export const useDisplayPlantCurrency = () => {
  const {currency} = useUpmPlantContext()

  return getCurrencySymbol(currency)
}
